<template>
	<page gradient-background>
		<detail-base>
			<template #base>
				<div class="customer flex-center">
					<div class="customer-count flex-column flex-center">
						<b>{{baseInfo.product_count}}</b>
						<p>产品数</p>
					</div>
					<div class="flex-grow">
						<p class="customer-name">{{baseInfo.customer_name}}</p>
						<div class="customer-tag flex-wrap">
							<c-state dict="afterSaleOrderStateDic" tag :value="baseInfo.status" @click.native="$refs.urgency.open()"></c-state>
						</div>
					</div>
				</div>
			</template>

			<template #info>
				<c-field label="工单负责人">{{baseInfo.charge_user_realname}}</c-field>
				<c-field label="工单参与人">{{baseInfo.group_user_realname ? baseInfo.group_user_realname.replaceAll(',', '、') : ''}}</c-field>
				<c-field label="预约时间">{{baseInfo.appointment_start_time}}</c-field>
				<c-field label="服务地址">{{baseInfo.customer_address}}</c-field>
			</template>

			<template #bottom>
				<div class="progress flex-center-cross">
					<p class="progress-label">当前安装进度：</p>
					<c-progress :rate="[baseInfo.completion_progress || 0, 1]" color="#00ACA9" style="width: 3.7rem"></c-progress>
				</div>
			</template>
		</detail-base>

		<detail-content :tabs="tabList">
			<template #base>
				<c-title>售后服务明细 ({{productList.length}})</c-title>
				<div>
					<goods-card
						v-for="(item, i) in productList"
						:key="i"
						:index="i + 1"
						:title="`${item.inventory_name || '-'} ${item.spec_model != item.inventory_name ? item.spec_model || '-' : ''}`"
						:info="[
							`长：${item.length || '-'}mm`,
							`宽：${item.width || '-'}mm`,
							`件数：${item.quantity || '-'}`,
							`环接方式：${item.connection_method || '-'}`,
							`数量：${item.pieces || '-'}`
						]"
						:remark="item.item_remark"
					></goods-card>
				</div>

				<c-title>其它信息</c-title>
				<c-detail>
					<c-detail-item label="工单编号">{{baseInfo.order_number}}</c-detail-item>
					<c-detail-item label="服务类型"><c-state dict="serviceTypeDic" :value="baseInfo.service_type"></c-state></c-detail-item>
					<c-detail-item label="售后类别"><c-state dict="afterSaleTypeDic" :value="baseInfo.aftersale_type"></c-state></c-detail-item>
					<c-detail-item label="售后网点">{{baseInfo.after_sale_outlet_name}}</c-detail-item>
					<c-detail-item label="预计服务时长">{{baseInfo.estimated_service_days}}天</c-detail-item>
					<c-detail-item label="创建时间">{{baseInfo.create_date}}</c-detail-item>
				</c-detail>
			</template>

			<template #member>
				<member-list>
					<member-item
						v-for="(item, i) in memberList"
						:key="i"
						:icon="item.head_photo"
						:name="item.user_realname"
						:tag="item.is_charge == 2 ? '负责人' : ''"
						:post="item.position_name"
					></member-item>
				</member-list>
			</template>
		</detail-content>

		<detail-handle>
			<template>
				<c-button v-if="baseInfo.evaluate_state == 1" @click="globalDialog('appraiseDetail', {props: {id: baseInfo.id}})">查看评价</c-button>
				<c-button v-if="baseInfo.status == 5 && baseInfo.evaluate_state == 0" size="detail" @click="mp.navigateWeb('/aftersales/appraise/edit', {id: baseInfo.id})">评价</c-button>
			</template>
		</detail-handle>
	</page>
</template>

<script>
	export default {
		props: {
			id: String
		},

		data() {
			return {
				baseInfo: {},
				productList: [],
				memberList: []
			}
		},

		computed: {
			tabList() {
				return [{
					name: '基础资料',
					value: 'base'
				}, {
					name: '服务人员' + (this.memberList.length ? `(${this.memberList.length})` : ''),
					value: 'member'
				}]
			}
		},

		mounted() {
			this.update();
			
			this.$onShow(() => {
				this.update();
			});
		},

		methods: {
			update() {
				this.request({
					url: '/after/sale/order/detail',
					data: {
						id: this.id
					},
					success: ({detailInfo, productList, memberList}) => {
						this.baseInfo = detailInfo;
						this.productList = productList;
						this.memberList = memberList;
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.customer {
		gap: .26rem;

		&-count {
			gap: .12rem;
			width: 1rem;
			height: 1rem;
			border-radius: .08rem;
			font-size: .22rem;
			color: #fff;
			background: var(--color-main);

			b {
				font-size: .36rem;
			}
		}

		&-name {
			font-size: .32rem;
			color: #28324B;
		}

		&-tag {
			gap: .12rem;
			margin-top: .2rem;
		}
	}

	.progress {
		height: .92rem;

		&-label {
			font-size: .26rem;
			color: #999;
		}
	}
</style>